import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Card } from 'react-bootstrap';
import '../Assets/Css/contact.css';
import productbanner from '../Assets/Images/contactus.avif';
import { MdEmail, MdLocationOn } from 'react-icons/md';
import { FaMobileAlt } from "react-icons/fa";

import { toast, Toaster } from 'react-hot-toast';
import axios from 'axios';
import { Spinner } from 'react-bootstrap';
import { BASE_URL } from '../BaseURL';

import { Helmet } from "react-helmet";

export default function Contact() {
  const [formData, setFormData] = useState({
    userName: '',
    email: '',
    mobile: '',
    requirements: '',
    address: '',
    message: ''
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);

    try {
      const response = await axios.post(`${BASE_URL}/enquiry/sendContactEnquiry`, formData);
      if (response.status === 200) {
        toast.success("Enquiry sent successfully!");
      }
    } catch (error) {
      toast.error("Failed to send enquiry.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Toaster />
      <div className="mainnav">
        <Helmet>
          <title>Contact Us | AIM Industrial Products</title>

          <meta
            name="description"
            content="Get in touch with AIM Industrial Products for high-quality stainless steel components. Reach out via email, phone, or visit our office or factory in Pimpri Chinchwad, Pune."
          />
          <meta
            name="keywords"
            content="Contact AIM Industrial Products, stainless steel parts Pune, industrial components, pharma components, dairy equipment, Bhosari, Shiv Rasta, Pimpri Chinchwad"
          />
          <meta name="author" content="AIM Industrial Products" />
          <meta name="robots" content="index, follow" />

          {/* Open Graph / Facebook */}
          <meta property="og:type" content="website" />
          <meta property="og:title" content="Contact Us | AIM Industrial Products" />
          <meta
            property="og:description"
            content="Looking for durable and compliant mechanical components? Contact AIM Industrial Products for product inquiries, support, and custom solutions."
          />
          <meta
            property="og:image"
            content="https://yourdomain.com/assets/contact-banner.jpg" // Replace with your actual image URL
          />
          <meta property="og:url" content="https://aimindproducts.com/contact" />

          {/* Twitter Card */}
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content="Contact Us – AIM Industrial Products" />
          <meta
            name="twitter:description"
            content="Reach out to AIM Industrial Products for reliable stainless steel components for your process lines and automation systems."
          />
          <meta
            name="twitter:image"
            content="https://yourdomain.com/assets/contact-banner.jpg" // Replace with your actual image URL
          />

          {/* Canonical URL */}
          <link rel="canonical" href="https://aimindproducts.com/contact" />
        </Helmet>
        {/* Banner Section */}
        <div className="about-banner position-relative text-white mb-4">
          <img
            src={productbanner}
            alt="About Banner"
            className="aboutbanner-image animate-banner-zoom"
          />
          <div className="maindesc position-absolute top-50 start-50 translate-middle text-center px-3">
            <h2 className="fw-bold glitch" data-text=" Contact Us">
              Contact Us
            </h2>
            <p className="lead">
              Looking for durable and compliant stainless steel components for your process lines or automation systems?
            </p>
          </div>
        </div>

        {/* Contact Info Section */}
        <Container className="mb-5">
          <Row className="text-center mb-4">
            <Col>
              <h2 className="Mainhead">Get in Touch</h2>

            </Col>
          </Row>
          <Row className="g-4">
            <Col md={6}>
              <Card className="h-100 shadow-sm">
                <Card.Body>
                  <h5 className="text-center fw-bold mb-3">Location</h5>

                  <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px', marginBottom: '10px' }}>
                    <MdLocationOn size={45} color="#004BA5" style={{ marginTop: '3px' }} />
                    <p className="mb-1">
                      <strong>Office :-</strong> C 306,Sahyadri Shrubbery, Shiv Rasta, Pimpri Chinchwad, Pune, Pimpri Chinchwad-412105, Maharashtra, India
                    </p>
                  </div>

                  <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px', marginBottom: '15px' }}>
                    <MdLocationOn size={40} color="#004BA5" style={{ marginTop: '3px' }} />
                    <p className="mb-1">
                      <strong>Factory :-</strong> Shop no 11 behind Mayuresh Hotel, Shantinagar, Bhosari, Pimpri Chinchwad Pune 411026
                    </p>
                  </div>

                  <a
                    href="mailto:info@aimindproducts.com"
                    style={{
                      textDecoration: 'none',
                      color: 'inherit',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '6px',
                      marginBottom: '10px'
                    }}
                  >
                    <MdEmail size={20} color="#004BA5" />
                    <p className="mb-0"><strong>Email —</strong> info@aimindproducts.com</p>
                  </a>

                  <a
                    href="https://wa.me/9822980560"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      textDecoration: 'none',
                      color: 'inherit',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '6px'
                    }}
                  >
                    <FaMobileAlt size={20} color="#004BA5" />
                    <p className="mb-0"><strong>Mobile -</strong> 9822980560</p>
                  </a>

                  <a
                    href="https://wa.me/9822980225"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      textDecoration: 'none',
                      color: 'inherit',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '6px'
                    }}
                  >
                    <FaMobileAlt size={20} color="#004BA5" />
                    <p className="mb-0"><strong>Mobile -</strong> 9822980225</p>
                  </a>

                  <div className='mt-3'>
                    <iframe
                      title="AIM Industrial Products"
                      src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7561.906328859332!2d73.84096059090889!3d18.62117624348246!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2c70761966c43%3A0xc0f8c7a5d62a8a09!2sAIM%20INDUSTRIAL%20PRODUCTS!5e0!3m2!1sen!2sin!4v1747122195892!5m2!1sen!2sin"
                      width="600"
                      height="450"
                      allowfullscreen=""
                      loading="lazy"
                      referrerpolicy="no-referrer-when-downgrade">

                    </iframe>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            {/* Contact Form */}
            <Col md={6}>
              <Card className="h-100 shadow-sm">
                <Card.Body>
                  <h5 className="text-center fw-bold mb-3">Contact Form</h5>
                  <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3">
                      <Form.Label className='fw-bold'>Name</Form.Label>
                      <Form.Control
                        type="text"
                        name="userName"
                        value={formData.userName}
                        onChange={handleChange}
                        placeholder="Enter your name"
                        required
                      />
                    </Form.Group>
                    <Row>
                      <Col lg={6}>
                        <Form.Group className="mb-3">
                          <Form.Label className='fw-bold'>Email</Form.Label>
                          <Form.Control
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            placeholder="Enter your email"
                            required
                          />
                        </Form.Group>
                      </Col>
                      <Col lg={6}>
                        <Form.Group className="mb-3">
                          <Form.Label className='fw-bold'>Mobile</Form.Label>
                          <Form.Control
                            type="tel"
                            name="mobile"
                            value={formData.mobile}
                            maxLength={10}
                            onChange={handleChange}
                            onInput={(e) => {
                              e.target.value = e.target.value.replace(/[^0-9]/g, '');
                            }}
                            placeholder="Enter your mobile"
                            required
                          />
                        </Form.Group>
                      </Col>
                    </Row>

                    <Form.Group className="mb-3">
                      <Form.Label className='fw-bold'>Requirements</Form.Label>
                      <Form.Control
                        type="text"
                        name="requirements"
                        value={formData.requirements}
                        onChange={handleChange}
                        placeholder="Enter your requirements"
                        required
                      />
                    </Form.Group>
                    <Form.Group className="mb-3">
                      <Form.Label className='fw-bold'>Address</Form.Label>
                      <Form.Control
                        as="textarea"
                        name="address"
                        value={formData.address}
                        onChange={handleChange}
                        rows={2}
                        placeholder="Enter your address..."
                        required
                      />
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label className='fw-bold'>Message</Form.Label>
                      <Form.Control
                        as="textarea"
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        rows={4}
                        placeholder="Your message..."
                        required
                      />
                    </Form.Group>

                    <div className="d-grid justify-content-center">
                      <Button type="submit" className="contactsubmitbtn" disabled={loading}>
                        {loading ? (
                          <>
                            <Spinner animation="border" size="sm" /> Sending...
                          </>
                        ) : (
                          'Submit'
                        )}
                      </Button>
                    </div>
                  </Form>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* CTA Button */}
          <Row className="mt-5 text-center">
            <Col>
              <a
                href="https://wa.me/9822980560 "
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
                <Button size="lg" className="reqbtn px-5 py-2 shadow">
                  Request a Quote
                </Button>
              </a>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}
